import { render, staticRenderFns } from "./SelectTeamsCompetitions.vue?vue&type=template&id=b8ed6642&scoped=true"
import script from "./SelectTeamsCompetitions.vue?vue&type=script&lang=js"
export * from "./SelectTeamsCompetitions.vue?vue&type=script&lang=js"
import style0 from "./SelectTeamsCompetitions.vue?vue&type=style&index=0&id=b8ed6642&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8ed6642",
  null
  
)

export default component.exports